module.exports = __webpack_public_path__ + "static/media/296296.39a5b853.png";